import { useField } from "formik"
import "emoji-mart/css/emoji-mart.css"
import data from "emoji-mart/data/twitter.json"
import { NimblePicker } from "emoji-mart"

export default function EmojiPickerField(props) {
  const { value } = props

  const [_field, _meta, helpers] = useField(props)

  const handleChange = (emoji) => {
    helpers.setValue(emoji.colons)
  }

  return (
    <NimblePicker
      set="twitter"
      data={data}
      emoji={value}
      showPreview={false}
      onSelect={handleChange}
      title="Pick an icon..."
      showSkinTones={false}
    />
  )
}
